export default {
    routes:[
        {
            path: '/userCenter',
            name: 'userCenter',
            component: r => require.ensure([], () => r(require('../page/user/userCenter')), 'userCenter'),
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/userInfo',
            name: 'userInfo',
            component: r => require.ensure([], () => r(require('../page/user/userInfo')), 'userInfo'),
            meta: {
                title: '修改个人信息'
            }
        },
        {
            path: '/partnerInfo',
            name: 'partnerInfo',
            component: r => require.ensure([], () => r(require('../page/user/partnerInfo')), 'partnerInfo'),
            meta: {
                title: '修改个人信息'
            }
        },
        {
            path: '/pay/recharge',
            name: 'recharge',
            component: r => require.ensure([], () => r(require('../page/user/recharge')), 'recharge'),
            meta: {
                title: '充值'
            }
        },
        {
            path: '/bill',
            name: 'bill',
            component: r => require.ensure([], () => r(require('../page/user/bill')), 'bill'),
            meta: {
                title: '账单'
            }
        },
        {
            path: '/cardTip',
            name: 'cardTip',
            component: r => require.ensure([], () => r(require('../page/user/cardTip')), 'cardTip'),
            meta: {
                title: '绑定会员卡'
            }
        },
        {
            path: '/bindCard',
            name: 'bindCard',
            component: r => require.ensure([], () => r(require('../page/user/bindCard')), 'bindCard'),
            meta: {
                title: '绑定会员卡'
            }
        },
        {
            path: '/bindCardPWD',
            name: 'bindCardPWD',
            component: r => require.ensure([], () => r(require('../page/user/bindCardPWD')), 'bindCardPWD'),
            meta: {
                title: '绑定会员卡'
            }
        },
        {
            path: '/bindMobile',
            name: 'bindMobile',
            component: r => require.ensure([], () => r(require('../page/user/bindMobile')), 'bindMobile'),
            meta: {
                title: '绑定手机'
            }
        },
        {
            path: '/:type/success',
            name: 'success',
            component: r => require.ensure([], () => r(require('../page/user/success')), 'success')
        },
        {
            path: '/orderList',
            name: 'orderListAll',
            component: r => require.ensure([], () => r(require('../page/user/orderList')), 'orderList'),
            meta: {
                title: '我的预约'
            }
        },
        {
            path: '/orderList/:type',
            name: 'orderList',
            component: r => require.ensure([], () => r(require('../page/user/orderList')), 'orderList'),
            meta: {
                title: '我的预约'
            }
        },
        {
            path: '/pay/o/:id',
            name: 'orderDetail',
            component: r => require.ensure([], () => r(require('../page/user/orderDetail')), 'orderDetail'),
            meta: {
                title: '我的订单'
            }
        },
        {
            path: '/orderTrans/:id',
            name: 'orderTrans',
            component: r => require.ensure([], () => r(require('../page/user/orderTrans')), 'orderTrans')
        },
        {
            path: '/au/:id',
            name: 'au',
            component: r => require.ensure([], () => r(require('../page/user/authOrderDetail')), 'au'),
            meta: {
                title: '我的订单'
            }
        },
        {
            path: '/coupon',
            name: 'coupon',
            component: r => require.ensure([], () => r(require('../page/user/coupon')), 'coupon'),
            meta: {
                title: '优惠券'
            }
        },
        {
            path: '/changeAccount',
            name: 'changeAccount',
            component: r => require.ensure([], () => r(require('../page/user/changeAccount')), 'changeAccount'),
            meta: {
                title: '更换账号'
            }
        },
        {
            path: '/invoiceOrder',
            name: 'invoiceOrder',
            component: r => require.ensure([], () => r(require('../page/user/invoiceOrder')), 'invoiceOrder'),
            meta: {
                title: '发票预约'
            }
        },
        {
            path: '/invoiceInfo',
            name: 'invoiceInfo',
            component: r => require.ensure([], () => r(require('../page/user/invoiceInfo')), 'invoiceInfo'),
            meta: {
                title: '发票信息'
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/user.js